// extracted by mini-css-extract-plugin
module.exports = {"featured":"Featured_featured__buiPt","wrapper":"Featured_wrapper__P44ug","link":"Featured_link__QnnfE","content":"Featured_content__4g+DX"};